import { Loader2 } from "lucide-react";

export function ServicesLoadingState() {
  return (
    <div className="py-16 text-center text-subtle">
      <Loader2 size={18} className="mr-2 inline animate-spin" /> Chargement...
    </div>
  );
}
